import Google from "assets/google.svg";
import Clutch from "assets/clutch.svg";
import Crowdin from "assets/crowdin.svg";
import G2 from "assets/g2.svg";
import Trustpilot from "assets/trustpilot.svg";
import Featured from "assets/featured.svg";
import GoodFirms from "assets/goodfirms.svg";
import UpCity from "assets/up.svg";
import Facebook from "assets/facebook.svg";

export const INDUSTRIES = [
  { data: "Automotive", link: "/industries/automotive" },
  { data: "Banking & Finance", link: "/industries/banking-finance" },
  { data: "Healthcare", link: "/industries/healthcare" },
  { data: "Gaming", link: "/industries/gaming" },
  { data: "High-Tech", link: "/industries/technology" },
  { data: "Military", link: "/industries/military" },
  { data: "Government", link: "/industries/government" },
  { data: "Luxury Brands", link: "/industries/luxury-brands" },
  { data: "Legal", link: "/industries/legal-services" },
];

export const RESOURCES = [
  { data: "About Us", link: "/about-tomedes" },
  { data: "ISO Certified", link: "/iso-certifications" },
  { data: "Quality Guaranteed", link: "/quality-policy" },
  { data: "Human Translation", link: "/human-translation.php" },
  {
    data: "Urgent Translation",
    link: "/translation-services/urgent-translation",
  },
  {
    data: "Text Summarization Tool",
    link: "/tools/text-summarizer",
  },
  {
    data: "Language Detection Tool",
    link: "/tools/language-detector",
  },
  {
    data: "Word Count Ratio Estimation Tool ",
    link: "/tools/word-count-ratio",
  },
  // { data: "Translators", link: "/translators" },
  // { data: "Localization Company", link: "/localization-company.php" },
  // {
  //   data: "Translation Rates Guide",
  //   link: "/translator-hub/translation-rates",
  // },
  // {
  //   data: "Best Translation Company",
  //   link: "https://themanifest.com/translation/services",
  // },
  // {
  //   data: "New York Translation Agency",
  //   link: "/locations/nyc-translation-services",
  // },
  // {
  //   data: "London Translation Agency",
  //   link: "/locations/london-translation-services",
  // },
  // { data: "Localization Company", link: "/localization-company.php" },
  // { data: "Localization Company", link: "/localization-company.php" },
  // { data: "Blog for Customers", link: "/business-center.php" },
  // { data: "Tomedes Insights", link: "/tomedes-insider.php" },
  // { data: "Translation News", link: "/translation-industry.php" },
  // { data: "Technology Tools", link: "/translation-technology" },
  // { data: "Supported file formats", link: "/supported-file-formats" },
  // { data: "Summary Tool", link: "/summary-tool" },
  // { data: "Word Count Ratio", link: "/word-count-ratio-tool" },
  // { data: "Careers", link: "/careers" },
  // { data: "Coronavirus", link: "/crisis-communication-center" },
  // { data: "Useful Links", link: "/useful-links" },
];

export const COMPLIMENTARYSERVICES = [
  { link: "Transcription" },
  { link: "Voice-over" },
  { link: "Closed Captioning" },
  { link: "Content Writing" },
  { link: "Desktop Publishing" },
];

export const locations = [
  { location: "Atlanta", link: "/locations/atlanta-translation-services" },
  { location: "Beaverton" },
  { location: "Chicago", link: "/locations/chicago-translation-services" },
  { location: "Houston", link: "/locations/houston-translation-services" },
  { location: "London", link: "/locations/london-translation-services" },
  {
    location: "Los Angeles",
    link: "/locations/los-angeles-translation-services",
  },
  { location: "Melbourne", link: "/locations/melbourne-translation-services" },
  { location: "Miami", link: "/locations/miami-translation-services" },
  { location: "New York City", link: "/locations/nyc-translation-services" },
  { location: "Ottawa", link: "/locations/ottawa-translation-services" },
  {
    location: "San Francisco ",
    link: "/locations/san-francisco-translation-services",
  },
  { location: "Toronto", link: "/locations/toronto-translation-services" },
  {
    location: "Washington DC",
    link: "/locations/washington-dc-translation-services",
  },
  // { location: "Boston", link: "/locations/boston-translation-services" },
  // { location: "Dallas", link: "/locations/dallas-translation-services" },
  // { location: "Denver", link: "/locations/denver-translation-services" },
  // {
  //   location: "Manchester ",
  //   link: "/locations/manchester-translation-services/",
  // },
  // {
  //   location: "Philadelphia",
  //   link: "/locations/philadelphia-translation-services",
  // },

  // { location: "Sydney", link: "/locations/sydney-translation-services" },
  // { location: "San Diego", link: "/locations/san-diego-translation-services" },
  // { location: "Seattle ", link: "/locations/seattle-translation-services" },
];

export const termCondition = [
  // { link: "Terms & Conditions", url: "/legal/terms-of-service" },
  { link: "Legal Policies", url: "/legal" },
  { link: "Cookie Policy", url: "/legal/cookie-policy" },
  // { link: "Standards & Goals", url: "/our-translation-company.php" },
];

export const AudioVisual = [
  { data: "Video translation", link: "/video-translation" },
  { data: "Audio translation", link: "/audio-translation" },
  { data: "Multilingual Transcription", link: "/transcription-services" },
];

export const Industries = [
  { data: "Legal", link: "/industries/legal-services" },
  {
    data: "Banking & Finance",
    link: "/industries/banking-translation-services",
  },
  // { data: "Healthcare", link: "/industries/healthcare-translation-services" },
  // { data: "Academic", link: "/industries/academic-translation-services" },
  { data: "Ecommerce", link: "/industries/ecommerce-translation-services" },
  {
    data: "Gaming",
    link: "/industries/gaming-translation-services",
  },
  {
    data: "Media",
    link: "/industries/media-translation-services",
  },
  // {
  //   data: "Life Sciences",
  //   link: "/industries/life-sciences-translation-services",
  // },
  {
    data: "Manufacturing",
    link: "/industries/manufacturing-translation-services",
  },
  // {
  //   data: "Fashion & Luxury ",
  //   link: "/industries/fashion-textile-translation-services",
  // },
  {
    data: "Automotive",
    link: "/industries/automotive-translation-services",
  },
  {
    data: "Travel & Tourism",
    link: "/industries/tourism-translation-services",
  },
];
//
export const Services = [
  {
    data: "Legal Translation",
    link: "/translation-services/legal-translation",
  },
  {
    data: "Medical Translation",
    link: "/translation-services/medical-translation",
  },
  {
    data: "Financial Translation",
    link: "/translation-services/financial-translation",
  },
  {
    data: "Marketing Translation ",
    link: "/translation-services/marketing-translation",
  },
  {
    data: "Technical Translation",
    link: "/translation-services/technical-translation",
  },
  // {
  //   data: "Elearning Translation",
  //   link: "/translation-services/elearning-translation",
  // },
  // { data: "Software Translation", link: "/localization-services/software" },
  {
    data: "Business Translation",
    link: "/translation-services/business-translation",
  },
  {
    data: "Human Translation",
    link: "/translation-services/human-translation",
  },
  {
    data: "Urgent Translation",
    link: "/translation-services/urgent-translation",
  },
  // {
  //   data: "Best Translation Services",
  //   link: "/translator-hub/15-best-translation-services",
  // },
];

export const Company = [
  {
    data: "Tomedes' Google Reviews",
    link: "https://www.google.com/search?q=tomedes+beaverton&rlz=1C1GCEA_enIL795IL795&oq=tomedes+beaverton&aqs=chrome..69i57j0i13j0i390l2.2319j0j9&sourceid=chrome&ie=UTF-8#lrd=0x54950d8bd3c5960d:0xecfe82a87609c06e,1,,,",
    imgUrl: Google,
  },
  {
    data: "Tomedes in Clutch",
    link: "https://clutch.co/profile/tomedes-translation-services",
    imgUrl: Clutch,
  },
  {
    data: "Tomedes in Crowdin",
    link: "https://store.crowdin.com/partners/tomedes",
    imgUrl: Crowdin,
  },
  {
    data: "Tomedes in G2",
    link: "https://www.g2.com/products/tomedes-translation-services/reviews",
    imgUrl: G2,
  },
  {
    data: "Tomedes in Trustpilot",
    link: "https://www.trustpilot.com/review/www.tomedes.com",
    imgUrl: Trustpilot,
  },
  {
    data: "Tomedes in Facebook",
    link: "https://www.facebook.com/Tomedes.translation/reviews",
    imgUrl: Facebook,
  },
  {
    data: "Tomedes in Featured Customers",
    link: "https://www.featuredcustomers.com/vendor/tomedes",
    imgUrl: Featured,
  },
  {
    data: "Tomedes in Goodfirms",
    link: "https://www.goodfirms.co/company/tomedes-translation-services",
    imgUrl: GoodFirms,
  },
  {
    data: "Tomedes in Upcity",
    link: "https://upcity.com/profiles/tomedes",
    imgUrl: UpCity,
  },
];
